






































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { Token } from "../api/types";

@Component({
  name: "token-modal",
})
export default class TokenModal extends Vue {
  @Prop({ default: null })
  token!: Token;
}
